(function(angular){
	'use strict';
	
	angular
		.module('iconModule')
		.factory('IconService', [
			'$q',
			'$templateRequest',
			'ICON_MAP',
			'STATIC_BASE_PATH',
			IconServiceFunction
		]);
	
	function IconServiceFunction(
		$q,
		$templateRequest,
		ICON_MAP,
		STATIC_BASE_PATH
	) {
		var factory = {
			getIconTemplate: getIconTemplate
		};

		return factory;

		function getIconTemplate(templateName) {
			var deferred = $q.defer();
			var templateUrl = ICON_MAP[templateName];

			if(templateUrl) {
				$templateRequest(STATIC_BASE_PATH + templateUrl, true).then(function(template) {
					deferred.resolve(template);
				});
			}

			return deferred.promise;
		}
	}
})(window.angular);